import { Capacitor } from '@capacitor/core'
import { AppUpdate } from '@capawesome/capacitor-app-update'
import { useCallback, useEffect } from 'react'

import { useAppState } from '@/capacitor/hooks/useAppState'

type AppUpdateMonitorProps = {
  onUpdateAvailable: (current: string, available?: string) => void
}

const AppUpdateMonitor = ({ onUpdateAvailable }: AppUpdateMonitorProps) => {
  const { active } = useAppState()

  // Helper Methods
  // ------------------------------------------------------------------------- /
  const isUpdateAvailable = useCallback(async () => {
    try {
      const { currentVersionCode, availableVersionCode } = await AppUpdate.getAppUpdateInfo()

      const isDifferent = currentVersionCode !== availableVersionCode

      if (isDifferent) {
        onUpdateAvailable(currentVersionCode, availableVersionCode)
      }

      return isDifferent
    } catch (error) {
      console.error(error)
    }
  }, [onUpdateAvailable])

  useEffect(() => {
    // Native only
    if (active && Capacitor.isNativePlatform()) {
      isUpdateAvailable()
    }
  }, [active, isUpdateAvailable])

  return null
}

export { AppUpdateMonitor }
